import { GitBranch, PlugZap } from "lucide-react";
import { Tile, Row, Chip } from "./Tile";
import { ago } from "../../lib/dash";

const NotConnected = ({ why }) => (
  <div data-testid="github-not-connected" className="dash-scroll flex min-h-0 flex-1 flex-col items-start justify-center gap-2 overflow-y-auto rounded-xl border border-dashed border-border p-3">
    <Chip testid="github-state">Not connected</Chip>
    <p className="text-[13px]">{why}</p>
    <p className="text-[11px] text-muted-foreground">
      A read-only fine-grained token for this one repository (Contents + Metadata: read) lets this tile show the latest
      commit on main and whether this server runs exactly that backend.
    </p>
  </div>
);

const matchChip = (gh) =>
  gh.checking ? <Chip testid="github-state" tone="blue">Checking</Chip>
    : gh.error ? <Chip testid="github-state" tone="amber">Check failed</Chip>
      : gh.match ? <Chip testid="github-state" tone="green">Matches this server</Chip>
        : <Chip testid="github-state" tone="amber">Differs from this server</Chip>;

export const GithubTile = ({ gh, tone, index }) => (
  <Tile id="github" index={index} tone={tone} kicker="Tile 2 · read-only" title="GitHub" action={<GitBranch className="h-4 w-4 text-muted-foreground" />}>
    {!gh.connected ? <NotConnected why={gh.why} /> : !gh.commit ? (
      <p className="flex items-center gap-2 text-sm text-amber-700"><PlugZap className="h-4 w-4" /> {gh.error}</p>
    ) : (
      <div className="dash-scroll min-h-0 flex-1 overflow-y-auto">
        <div className="mb-2">{matchChip(gh)}</div>
        <Row dense label="Repository" value={gh.repo} />
        <Row dense label="Latest on main" testid="github-sha" value={gh.commit.sha.slice(0, 12)} />
        <Row dense label="Message" value={gh.commit.message} />
        <Row dense label="Committed" value={ago(gh.commit.at)} />
        <Row dense label="This server" value={(gh.local_backend_sha || "").slice(0, 12)} />
      </div>
    )}
  </Tile>
);
